module.exports = __webpack_public_path__ + "static/media/SaleZeroMatching.449026a1.svg";